import { makeStyles } from '@rbx/ui';

const useReferenceDeprecationWarningStyles = makeStyles()((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: theme.palette.surface[0],
  },
  iconWrapper: {
    paddingLeft: '4px',
    display: 'flex',
    flexShrink: 0,
    color: theme.palette.warning.dark,
  },
}));

export default useReferenceDeprecationWarningStyles;
